import type { CommandData } from '../types'

export function setInputValue(value: string) {
  const message: CommandData = {
    isFromNetwatch: true,
    command: 'setInputValue',
    value,
  }
  window.postMessage(message)
}
